import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import { REACT_APP_DOMAIN } from '../common/constants'
import useAuth from '../hooks/useAuth'

function PrivateRoutes() {
  const { pathname } = useLocation()
  const { auth } = useAuth()

  return auth.accessToken ? (
    <Outlet />
  ) : (
    window.location.replace(
      `${REACT_APP_DOMAIN}/Account/LogOn?ReturnUrl=${pathname}`,
    )
  )
}

export default PrivateRoutes
